import toast from "react-hot-toast";
import * as api from "../Api";

export const createRegulator = (postData) => async (dispatch) => {
  let creatingId;
  try {
    creatingId = toast.loading("Creating regulator...");
    const { data } = await api.createRegulator(postData);
    dispatch({ type: "CREATE_REGULATOR", payload: data });
    toast.remove(creatingId);
    toast.success("Regulator created successfully");
  } catch (error) {
    toast.remove(creatingId);
    toast.error(error.message);
  }
};
export const getAllRegulators = () => async (dispatch) => {
  try {
    const { data } = await api.getRegulator();
    dispatch({ type: "GET_ALL_REGULATORS", payload: data });
  } catch (error) {}
};
export const deleteRegulator = (id) => async (dispatch) => {
  let deletingId;
  try {
    deletingId = toast.loading("Deleting regulator...");
    await api.deleteRegulator(id);
    dispatch({ type: "DELETE_REGULATOR", payload: id });
    toast.remove(deletingId);
    toast.success(`Regulator deleted successfully`);
  } catch (error) {
    toast.remove(deletingId);
    toast.error(error.message);
  }
};
